// src/hooks/useOrgConfigData.js
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiConstants from "../constants/apiConstants";
import axios from "axios";
import { setOrgConfigData } from "../components/Redux/Features/userLoginSlice";
const USE_MOCK = false;
export const useOrgConfigData = (refreshKey) => {
  const dispatch = useDispatch();

  const { userToken } = useSelector((state) => state.userToken);

  const orgConfigData = useSelector(
    (state) => state.userLogin.org_config_data
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        //  TEST MODE
        if (USE_MOCK) {
          const mockData = [{ test: "hii" }];

          dispatch(setOrgConfigData(mockData));
          return;
        }

        //  REAL API
        const response = await axios.post(
          `${apiConstants.GET_API_URL}get_org_config_data`,
          {},
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );

        dispatch(setOrgConfigData(response.data.orgDetails));
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [dispatch, refreshKey, userToken]);

  return orgConfigData;
};